import { http } from '@/utils/http'

export const BPBASE = window.$envUtils('VUE_APP_BP_SERVICE')

/**
 * 获取评价等级数据列表
 */
export const listByPage = async ({ channelId, pageNum, pageSize }) => {
  const params = {
    channelId,
    pageNum,
    pageSize
  }
  return new Promise((resolve, reject) => {
    http.get(`${BPBASE}/hotQA/listByPage`, { params }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

/**
 * 获取所以评价等级数据列表
 */
export const listAll = async (channelId) => {
  const params = {
    channelId
  }
  return new Promise((resolve, reject) => {
    http.get(`${BPBASE}/hotQA/listAll`, { params }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

/**
 * 修改评价等级信息
 */
export const update = async (evaluteGrades) => {
  return new Promise((resolve, reject) => {
    http.post(`${BPBASE}/hotQA/update`, { data: evaluteGrades }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

/**
 * 新增评价等级信息
 */
export const insert = async (evaluteGrade) => {
  return new Promise((resolve, reject) => {
    http.post(`${BPBASE}/hotQA/insert`, { data: evaluteGrade }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

/**
 * 新增评价等级信息
 */
export const insertMutil = async (evaluteGrades) => {
  return new Promise((resolve, reject) => {
    http.post(`${BPBASE}/hotQA/insertMutil`, { data: evaluteGrades }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

/**
 * 删除评价等级数据
 */
export const deleteByIds = async (ids) => {
  return new Promise((resolve, reject) => {
    http.delete(`${BPBASE}/hotQA/deleteByIds`, { data: ids }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

export const updateChannelId = async (oldChannelId, newChannelId) => {
  const params = {
    oldChannelId: oldChannelId,
    newChannelId: newChannelId
  }
  return new Promise((resolve, reject) => {
    http.post(`${BPBASE}/hotQA/updateChannelId`, { params }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}
